import * as arMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ar-SA/component.library.json';
import * as bgMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/bg-BG/component.library.json';
import * as caMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ca-ES/component.library.json';
import * as csMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/cs-CZ/component.library.json';
import * as daMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/da-DK/component.library.json';
import * as deMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/de-DE/component.library.json';
import * as elMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/el-GR/component.library.json';
import * as enUpperMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/en-UPPER/component.library.json';
import * as enUsMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/en-us/component.library.json';
import * as esMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/es-ES/component.library.json';
import * as etMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/et-EE/component.library.json';
import * as euMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/eu-ES/component.library.json';
import * as fiMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/fi-FI/component.library.json';
import * as frMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/fr-FR/component.library.json';
import * as glMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/gl-ES/component.library.json';
import * as heMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/he-IL/component.library.json';
import * as hrMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/hr-HR/component.library.json';
import * as huMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/hu-HU/component.library.json';
import * as idMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/id-ID/component.library.json';
import * as itMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/it-IT/component.library.json';
import * as jaMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ja-JP/component.library.json';
import * as koMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ko-KR/component.library.json';
import * as ltMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/lt-LT/component.library.json';
import * as lvMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/lv-LV/component.library.json';
import * as nbMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/nb-NO/component.library.json';
import * as nlMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/nl-NL/component.library.json';
import * as plMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/pl-PL/component.library.json';
import * as ptBRMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/pt-BR/component.library.json';
import * as ptPTMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/pt-PT/component.library.json';
import * as roMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ro-RO/component.library.json';
import * as ruMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/ru-RU/component.library.json';
import * as skMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/sk-SK/component.library.json';
import * as slMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/sl-SI/component.library.json';
import * as srCyrlMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/sr-Cyrl-RS/component.library.json';
import * as srLatnMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/sr-Latn-RS/component.library.json';
import * as svMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/sv-SE/component.library.json';
import * as thMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/th-TH/component.library.json';
import * as trMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/tr-TR/component.library.json';
import * as ukMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/uk-UA/component.library.json';
import * as viMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/vi-VN/component.library.json';
import * as zhCNMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/zh-CN/component.library.json';
import * as zhTWMessages from '@microsoft-commerce/purchase-blends-component-library/dist/lang/zh-TW/component.library.json';
export const getPBMessagesByLocale = (locale)=>{
    switch(locale){
        case 'ar-sa':
            return arMessages.default;
        case 'bg-bg':
            return bgMessages.default;
        case 'ca-es':
            return caMessages.default;
        case 'cs-cz':
            return csMessages.default;
        case 'da-dk':
            return daMessages.default;
        case 'de-de':
            return deMessages.default;
        case 'el-gr':
            return elMessages.default;
        case 'en-upper':
            return enUpperMessages.default;
        case 'en-us':
            return enUsMessages.default;
        case 'es-es':
            return esMessages.default;
        case 'et-ee':
            return etMessages.default;
        case 'eu-es':
            return euMessages.default;
        case 'fi-fi':
            return fiMessages.default;
        case 'fr-fr':
            return frMessages.default;
        case 'gl-es':
            return glMessages.default;
        case 'he-il':
            return heMessages.default;
        case 'hr-hr':
            return hrMessages.default;
        case 'hu-hu':
            return huMessages.default;
        case 'id-hd':
            return idMessages.default;
        case 'it-it':
            return itMessages.default;
        case 'ja-jp':
            return jaMessages.default;
        case 'ko-kr':
            return koMessages.default;
        case 'lt-lt':
            return ltMessages.default;
        case 'lv-lv':
            return lvMessages.default;
        case 'nb-no':
            return nbMessages.default;
        case 'nl-nl':
            return nlMessages.default;
        case 'pl-pl':
            return plMessages.default;
        case 'pt-br':
            return ptBRMessages.default;
        case 'pt-pt':
            return ptPTMessages.default;
        case 'ro-ro':
            return roMessages.default;
        case 'ru-ru':
            return ruMessages.default;
        case 'sk-sk':
            return skMessages.default;
        case 'sl-si':
            return slMessages.default;
        case 'sr-cyrl-rs':
            return srCyrlMessages.default;
        case 'sr-latn-rs':
            return srLatnMessages.default;
        case 'sv-se':
            return svMessages.default;
        case 'th-th':
            return thMessages.default;
        case 'tr-tr':
            return trMessages.default;
        case 'uk-ua':
            return ukMessages.default;
        case 'vi-vn':
            return viMessages.default;
        case 'zh-cn':
            return zhCNMessages.default;
        case 'zh-tw':
            return zhTWMessages.default;
        default:
            return enUsMessages.default;
    }
}; // TODO RANSHAMAY/ YOMANOR - WEBPACK (5) once dynamic imports are availale, use code below insted of manual import
 // import { AllLanguages } from '@microsoft-commerce/purchase-blends-component-library';
 // // TODO: copied from "client" project, maybe share this at some point? -marcodi
 // const makeImport: (lang: string) => () => Promise<IMessages> =
 //   (lang: string) =>
 //   // tslint:disable-next-line: max-line-length
 //   () =>
 //     import(`@microsoft-commerce/purchase-blends-component-library/dist/lang/${lang}/component.library.json`)
 // const langs: LazyLangMap = new Map<string, () => Promise<IMessages>>(
 //   ['en-UPPER', ...AllLanguages].map((l: string) => [l.toLowerCase(), makeImport(l)]) as any
 //  as unknown as IMessages);
 // export default langs;
